<template>
  <div>
    <SearchBar :showSelect="false" :id="id" @getSearchParams="getSearchParams" />
    <div class="datatable">
      <el-table :data="tableData" style="width: 100%" v-loading="loading">
        <el-table-column label="头像" width="150">
          <template slot-scope="scope">
            <el-image class="headerimg" :src="scope.row.headImg" lazy></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="nickname" label="昵称"></el-table-column>
        <el-table-column prop="location" label="国家/省份/城市" width="240"></el-table-column>
        <el-table-column prop="openId" label="openid" width="300"></el-table-column>
        <el-table-column prop="unsubscribedDate" label="取关时间" :formatter="formatDate"></el-table-column>
        <el-table-column prop="subscribedDuration" label="关注时长" :formatter="hours2Days"></el-table-column>
        <el-table-column label="标签" align="center">
          <template slot-scope="scope">
            <el-popover placement="bottom-end" width="200" trigger="hover" offset="30">
              <el-tag
                class="tagsitem"
                type="info"
                v-for="tag in scope.row.customTags"
                :key="tag.customTagId"
                size="mini"
                effect="plain"
                color="#fff"
                style="margin: 0 10px 10px 0"
              >{{tag.name}}</el-tag>
              <p class="notags" v-if="showP(scope.row.customTags)">无标签</p>
              <el-button type="text" slot="reference">查看</el-button>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagina">
      <el-pagination
        layout="prev, pager, next"
        :total="itotal"
        :page-size="isize"
        @current-change="v => ipage = v"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import SearchBar from '@/components/usermanaSearchBar';
import moment from 'moment';

export default {
  name: 'UserManaFollow',
  components: {
    SearchBar,
  },
  props: ['id'],
  data() {
    return {
      loading: true,
      visible: false,
      searchParams: {
        subscribedScene: 'ALL',
        subscribe: false,
        begin: moment()
          .subtract(1, 'years')
          .format('YYYY-MM-DD HH:mm:ss'),
      },
      ipage: 1,
      isize: 10,
      itotal: 0,
      tableData: [],
    };
  },

  watch: {
    searchParams: {
      handler(val) {
        this.ipage = 1;
        this.getData();
      },
      deep: true,
    },
    ipage() {
      this.getData();
    },
  },

  methods: {
    showP(data) {
      return !data || data.length == 0;
    },
    async getData() {
      this.loading = true;
      let url = `/api/${this.id}/followers`;
      let res = await this.$http.get(url, {
        params: Object.assign(
          {
            page: this.ipage,
            size: this.isize,
          },
          this.searchParams,
        ),
      });
      if (res) {
        this.itotal = res.totalSize;
        this.tableData = res.list;
      }
      setTimeout(() => {
        this.loading = false;
      }, 300);
    },
    getSearchParams(val) {
      let ret = { ...this.searchParams, ...val };
      this.searchParams = ret;
    },
    formatDate(row) {
      return moment(row.unsubscribedDate).format('YYYY-MM-DD');
    },
    hours2Days(row) {
      let h = row.subscribedDuration;
      if (h < 24) {
        return '少于1天';
      }
      return `${Math.ceil(h / 24)} 天`;
    },
  },

  created() {
    this.getData();
  },
};
</script>
<style lang="scss" scoped>
.tagsitem {
  padding: 0 10px;
  margin-right: 12px;
  margin-bottom: 10px;
  height: 24px;
  line-height: 23px;
}
.datatable {
  margin-top: 15px;
  min-height: 560px;
  background: #fff;

  /deep/ .el-table th {
    background: #fff;
  }

  .headerimg {
    width: 46px;
    height: 46px;
  }
}
.notags {
  display: block;
  padding: 20px 0;
  text-align: center;
  font-size: 12px;
  color: #606266;
}
.pagina {
  margin: 20px 0;
  text-align: center;
}
</style>
